/**
 * @file
 * Block: Category Menu.
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.medihumBlockCateoryMenu = {
    attach: function (context, settings) {
      var $context = $(context);

      $('.block-category-menu').once('category-menu-process').each(function () {
        var timeout;
        var $nav = $(this);

        // Add custom hover class with small delay to move around expanded menu
        $nav.find('.menu--depth-1 > li').hover(function () {
          var element = $(this);

          clearTimeout(timeout);
          timeout = setTimeout(function () {
            $('li.d-hover', element.parent()).removeClass('d-hover');
            if (element.find('ul.menu--depth-2').length) {
              element.addClass('d-hover');
            }
          }, 100);
        }, function () {
          var element = $(this);

          clearTimeout(timeout);
          timeout = setTimeout(function () {
            element.removeClass('d-hover');
          }, 500);
        });
      });
    }
  };

})(jQuery, Drupal);
